export const getAppUrl = (path = "/") => {
  const rawBasename = process.env.REACT_APP_BASENAME || "";
  const normalizedBasename = rawBasename.replace(/^\/+|\/+$/g, "");
  const basename = normalizedBasename ? `/${normalizedBasename}` : "";
  const route = `/${String(path || "/").replace(/^\/+/, "")}`;

  if (basename && (route === basename || route.startsWith(`${basename}/`))) {
    return route;
  }

  return `${basename}${route}` || "/";
};
